/**
 * Created by staffanrantzow on 19/04/16.
 */

import axios from 'axios';
import {APIResult} from '../http';
import CurrencyEntity from './currency-entity';

class CurrenciesService {

  constructor () {
    this.currencies = null;
  }

  hydrate (currency) {
    var attr = currency.attributes;

    return new CurrencyEntity(
      currency.id,
      attr.active,
      attr.code,
      attr.exchange_rate,
      attr.name,
      attr.standard,
      attr.updated_at
    );
  }

  hydrateCollection (data) {
    var currencies = [];

    for (let currency of data) {
      currencies.push(this.hydrate(currency));
    }

    return currencies;
  }

  get () {
    if (this.currencies) {
      return Promise.resolve(this.currencies);
    } else {
      return this.fetchCurrencies();
    }
  }

  fetchCurrencies () {
    return axios.get('backend://currencies')
    .then((response) => {
      var currencies = this.hydrateCollection(response.data.data);
      return new APIResult(currencies, response.data.meta);
    });
  }

}

export default new CurrenciesService();



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/currencies/currencies-service.js
 **/